import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { MenuItem } from './MenuItem';
import { useMenuList } from './menus';
import './style.scss';

export type MenuListProps = {
  className?: string;
};

export function MenuList({ className }: MenuListProps) {
  const { getMenus, defaultMenus } = useMenuList();
  const [menus, setMenus] = useState<any[]>(defaultMenus);
  useEffect(() => {
    getMenus().then((res) => {
      setMenus(res);
    });
  }, []);
  return <div className={clsx(className, 'header-menu')}>{menus?.map((menu) => <MenuItem key={menu.title} menu={menu} />)}</div>;
}
